import type { UseListProps } from '@ztechapps/common.hook'
import { StorageType, useList, useUserTimeZone } from '@ztechapps/common.hook'
import { adjustmentListFragment } from './graphql'
import type { SetOptional } from 'type-fest'
import { gql } from '@apollo/client'

export const adjustmentListQuery = gql`
  query allAdjustment($filter: JSON!, $options: JSON) {
    allAdjustment(filter: $filter, options: $options) {
      ...adjustmentListFragment
      remarks
    }
    allAdjustmentMeta(filter: $filter) {
      count
    }
  }
  ${adjustmentListFragment}
`

export const useAdjustmentList = ({ listActionOptions = {}, query, ...props }: SetOptional<UseListProps, 'query'>) => {
  const timeZone = useUserTimeZone()

  query = query ?? adjustmentListQuery

  const finalDefaultListActions = {
    ...listActionOptions,
    storageType: StorageType.localStorage,
    timeZone,
  }

  return useList({
    query,
    ...props,
    limit: 100,
    sort: { createdAt: -1 },
    listActionOptions: finalDefaultListActions,
  })
}
